import { cardSchema, type Card, type UpdateCardBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const patchCard = (id: string, body: UpdateCardBody): Promise<unknown> =>
  apiRequest<unknown>(`/cards/${id}`, { method: 'PATCH', body });

export const updateCard = async (id: string, body: UpdateCardBody): Promise<Card> =>
  cardSchema.parse(await patchCard(id, body));
